define( 'models/fieldRepeaterTemplateFields',[], function() {
	/**
	 * A Repeatable Fieldset builds every fieldset from one template array of
	 * field definitions. Those definitions carry nested state 鈥 a list field's
	 * `options` / `image_options` 鈥 and the list controllers write the current
	 * selection back onto those option objects while rendering. Handing the same
	 * nested objects to more than one fieldset therefore lets one fieldset's
	 * answers leak into the next fieldset built from the template.
	 *
	 * Every fieldset gets its own deep copy so no fieldset can observe another's
	 * state. See https://github.com/Saturday-Drive/ninja-forms/issues/6745
	 *
	 * @param  {Array} fields Field definitions.
	 * @return {Array}        An independent deep copy.
	 */
	return function( fields ) {
		if ( ! fields || ! fields.length ) {
			return fields;
		}

		return jQuery.extend( true, [], fields );
	};
} );

